import { IMessage } from "@interfaces";

/**
 * Access-Guide GUIDELINES (TypeId=3 messages) are template-level and are
 * delivered only inside the post-booking welcome book — never on the guest
 * website. They must stay disjoint from the property HOUSE RULES
 * (no_smoking / pets / quiet / …), which own the website.
 *
 * The shared message catalog still contains legacy house-rule concepts
 * (ممنوع التدخين / الحيوانات الأليفة / الهدوء) that now belong exclusively to
 * House Rules. We hide those from the guidelines picker (so a host can no longer
 * add them as a guideline) and drop them from a template's initial selection (so
 * re-saving an older template stops carrying them). Matched by concept root-word
 * so a spelling variant (e.g. the legacy "اليفة" vs "الأليفة") is still caught.
 */
export const HOUSE_RULE_CONCEPT_TERMS = ["تدخين", "حيوان", "هدوء"];

export const isHouseRuleConcept = (m: Pick<IMessage, "title" | "content">): boolean => {
  const text = `${m.title ?? ""} ${m.content ?? ""}`;
  return HOUSE_RULE_CONCEPT_TERMS.some((term) => text.includes(term));
};
